/* eslint-disable import/prefer-default-export */
import userProjectConfigModel from '$$userProjectConfigModel';
import app from '$$app';
import projectsModel from '$$projectModel';
import projectComponent from '../../Project';
import ganttViewModel from '$$ganttViewModel';
import globalStore from '$$globalStore';
import _ from '../../../libs/lodash';

export function onProjectConfigUpdated(projectId, config) {
  const ganttIDs = ganttViewModel.getGanttIDs();
  const isSameProjectOpen = _.includes(ganttIDs, +projectId);

  const projectData = projectsModel.getItem(projectId);

  if (projectData) {
    projectData.config = config || projectData.config;
    projectData.config = userProjectConfigModel.getUserConfigByGanttIdAndMergeToProjectConfig(projectId, projectData.config);
    projectComponent.onChangeProjectData(projectData);
    app.trigger('collaboration:updatedModels', {});
    if (isSameProjectOpen) {
      app.trigger('project-calendar:change', +projectId);
      app.trigger('settings:days:collaboration', +projectId);
      app.trigger('project-config:change', +projectId, projectData.config);
    }
  } else {
    const projectTasksData = globalStore.getters['tasksModel/getItem'](projectId);

    projectTasksData.workloadData.durationData = config.durationData;
    globalStore.commit('tasksModel/updateProjectTasksData', projectTasksData);
    app.trigger('project-calendar:change', +projectId, config.durationData);
  }
}
